var map = {
	"./Festo_logo.jpg": 2350,
	"./abb.jpg": 4714,
	"./abb.png": 9038,
	"./acc.png": 2924,
	"./advantec.png": 8129,
	"./apollo.jpg": 4246,
	"./areva.png": 7362,
	"./atg.jpg": 1557,
	"./atlas.png": 3746,
	"./baker.png": 3440,
	"./cairn.png": 370,
	"./cryolar.png": 1819,
	"./doosan.png": 2543,
	"./emerson.png": 4346,
	"./endh.png": 5490,
	"./fls.png": 134,
	"./forbes.png": 5418,
	"./ge.png": 5351,
	"./ge.svg": 7297,
	"./honeywell.png": 4226,
	"./knpc.png": 7507,
	"./koc.png": 7206,
	"./landt.png": 5934,
	"./mayek.png": 5928,
	"./petrofac.png": 9555,
	"./pfizer.png": 7769,
	"./saint.jpg": 6104,
	"./schu.png": 7656,
	"./se.jpg": 6403,
	"./se.png": 4315,
	"./siemens.png": 9905,
	"./suez.png": 6246,
	"./ten.png": 2538,
	"./toshiba.jpg": 9519,
	"./yogkawa.png": 1008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8269;